import { useState } from "react";
import { FiX } from "react-icons/fi";
const activities = [
  {
    title: "YOGA",
    subtitle: "Verbundenheit von K\xF6rper, Geist und Seele",
    image: "/images/Hiru/yoga_01-1348x598.webp",
    intro: "Im Rahmen unseres Retreats ist Yoga ein unverzichtbarer Bestandteil der ayurvedischen Lehren und eines gesunden Lebensstils. Durch Atem\xFCbungen und sanfte K\xF6rperbewegungen in Verbindung mit entspannenden Asanas und tiefen Entspannungspraktiken finden Sie wieder zu mehr Beweglichkeit, innerer Ruhe und klarer Geisteshaltung.",
    details: [
      "Mit Fokus auf Hatha Yoga bringen wir K\xF6rper und Geist durch ruhige Haltungen und tiefe Atemtechniken in Einklang.",
      "Die \xDCbungen sind bewusst leicht und angenehm aufgebaut, damit auch Einsteiger sicher und ohne Druck teilnehmen k\xF6nnen.",
      "Ideal als Selbstf\xFCrsorge nach einer Behandlung oder als entspannender Alltagserg\xE4nzer."
    ]
  },
  {
    title: "Qigong",
    subtitle: "Meditation in Bewegung",
    image: "/images/Hiru/tai-chi.webp",
    intro: "Eine traditionelle Praxis, bei der sanfte Bewegungen und bewusste Atmung den Fluss innerer Energie harmonisieren und ausbalancieren.",
    details: [
      "Qigong, verwurzelt in der Traditionellen Chinesischen Medizin, f\xF6rdert Beweglichkeit und nat\xFCrliche Selbstheilungskr\xE4fte.",
      "Meditation, Atemtechnik und Bewegung verschmelzen zu einer tiefen Erfahrung von innerem Gleichgewicht.",
      "W\xE4hrend Ihres Aufenthalts finden auch Gruppen\xFCbungen statt, die Ihnen entspannte Momente schenken."
    ]
  },
  {
    title: "Musiktherapie",
    subtitle: "Heilende Kl\xE4nge und Harmonie",
    image: "/images/Hiru/sidharspieler-1348x598.webp",
    intro: "Die Schwingungen der Musik wirken sanft auf K\xF6rper und Geist und f\xFChren in eine tiefere Sense of Calm.",
    details: [
      "Melodien aus der indischen Tradition sprechen die Sinne auf sanfte Weise an und f\xF6rdern innere Ruhe.",
      "In Kombination mit ayurvedischen Behandlungen verst\xE4rken sie Entspannung und emotionale Stabilit\xE4t.",
      "In ruhiger Atmosph\xE4re erleben Sie eine besondere Verbindung aus Klang, Atem und innerem Frieden."
    ]
  },
  {
    title: "Meditation",
    subtitle: "In der Stille die innere Balance finden",
    image: "/images/Hiru/IMG_4272-e1734079223142.webp",
    intro: "Eine ruhige Praxis, bei der Sie Ihre Aufmerksamkeit nach innen richten und den Geist kl\xE4ren k\xF6nnen.",
    details: [
      "Unter der Anleitung eines buddhistischen M\xF6nchs f\xFChren Atemtechniken und Achtsamkeit zu tiefer Entspannung.",
      "Sie k\xF6nnen die t\xE4gliche Hektik hinter sich lassen und Zeit f\xFCr innere Stabilit\xE4t und Selbstwahrnehmung gewinnen.",
      "Meditation ist ein wichtiger Bestandteil, um die Wirkung der ayurvedischen Behandlungen noch weiter zu vertiefen."
    ]
  }
];
const ActivitiesCards = () => {
  const [selectedActivity, setSelectedActivity] = useState(null);
  return <section className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
            <div className="mx-auto container">
                <div className="mx-auto max-w-3xl text-center">
                    <div className="mx-auto mb-6 h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />
                    <h2 className="font-serif text-3xl font-semibold text-[#0f2a1f] sm:text-4xl">
                        Unsere Erlebnisse
                    </h2>
                    <p className="mt-4 text-lg leading-relaxed text-[#4a4a4a] sm:text-xl">
                        Entdecken Sie eine vielfältige Auswahl an Programmen, die Körper, Geist und Seele in Einklang mit Ayurveda bringen.
                    </p>
                </div>

                <div className="mt-12 grid gap-8 md:grid-cols-2 xl:grid-cols-4">
                    {activities.map((activity) => <article
    key={activity.title}
    className="group overflow-hidden rounded-[2rem] border border-[#e6d8b8] bg-white shadow-[0_20px_60px_-25px_rgba(7,19,13,0.25)]"
  >
                            <div className="relative h-72 overflow-hidden sm:h-80">
                                <img
    src={activity.image}
    alt={activity.title}className="object-cover transition duration-500 group-hover:scale-105" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                            </div>

                            <div className="p-6">
                                <p className="text-sm font-semibold uppercase tracking-[0.3em] text-[#F28600]">
                                    {activity.title}
                                </p>
                                <h3 className="mt-3 font-serif text-2xl text-[#0f2a1f]">
                                    {activity.subtitle}
                                </h3>
                                <p className="mt-3 text-sm leading-7 text-[#5f5f5f]">
                                    {activity.intro}
                                </p>

                                <button
    type="button"
    onClick={() => setSelectedActivity(activity)}
    className="mt-6 inline-flex items-center rounded-full border border-[#0f2a1f] px-5 py-2.5 text-sm font-semibold text-[#0f2a1f] transition hover:bg-[#0f2a1f] hover:text-white"
  >
                                    Mehr erfahren
                                </button>
                            </div>
                        </article>)}
                </div>
            </div>

            {selectedActivity && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-6 backdrop-blur-sm">
                    <div className="relative w-full max-w-3xl overflow-hidden rounded-[2rem] bg-[#fffdf8] shadow-2xl">
                        <button
    type="button"
    onClick={() => setSelectedActivity(null)}
    className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-[#0f2a1f] shadow transition hover:bg-white"
    aria-label="Aktivitätsdetails schließen"
    title="Schließen"
  >
                            <FiX className="h-5 w-5" aria-hidden="true" />
                        </button>

                        <div className="relative h-72 w-full sm:h-80">
                            <img
    src={selectedActivity.image}
    alt={selectedActivity.title}className="object-cover" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                            <div className="absolute bottom-0 left-0 p-6 text-white">
                                <p className="text-sm uppercase tracking-[0.3em] text-[#ffb347]">
                                    {selectedActivity.title}
                                </p>
                                <h3 className="mt-2 font-serif text-2xl sm:text-3xl">
                                    {selectedActivity.subtitle}
                                </h3>
                            </div>
                        </div>

                        <div className="max-h-[60vh] overflow-y-auto p-6 sm:p-8">
                            <p className="text-base leading-8 text-[#4a4a4a]">
                                {selectedActivity.intro}
                            </p>

                            <ul className="mt-6 space-y-3">
                                {selectedActivity.details.map((detail) => <li key={detail} className="flex gap-3 text-base leading-7 text-[#4a4a4a]">
                                        <span className="mt-2 h-2.5 w-2.5 shrink-0 rounded-full bg-[#F28600]" />
                                        <span>{detail}</span>
                                    </li>)}
                            </ul>
                        </div>
                    </div>
                </div>}
        </section>;
};
export default ActivitiesCards;
